module.exports = __webpack_public_path__ + "static/professional-528460b326d123c13f02e35f44bdad40.png";